<template>
  <div>
    <div class="d-flex border-bottom mb-4 px-2 align-items-center justify-content-between">
      <div class="mb-3">
        <p class="text--secondary font-weight-bold mb-0">
          List
        </p>
      </div>
      <button class="btn btn--secondary mb-3" @click="$emit('showRoleForm', {type: 'create', name: ''})">Add New</button>
    </div>

    <table class="table table-responsive-sm table-bordered border-0">
      <caption class="d-none"></caption>
      <thead>
        <tr>
          <th scope="col">S/N</th>
          <th scope="col">Name</th>
          <th scope="col">Permissions</th>
          <th scope="col">Actions</th>
        </tr>
      </thead>
      <tbody>
       <tr v-for="(role, index) in roles" :key="role.id">
         <td>{{ index + 1 }}</td>
         <td>{{ role.name }}</td>
         <td>
           <template v-if="role.permissions.length > 0">
              <span class="badge badge-info p-1 rounded-0 m-1" v-for="(permission, index) in role.permissions" :key='index'>{{ permission.name }}</span>
           </template>
           <template v-else>
             <span>No Permissions</span>
           </template>
         </td>
         <td>
           <div class="d-flex">
             <span class="bg--primary text-white py-1 px-2 mr-2 pointer" @click="$emit('showRoleForm', {type: 'edit', role})">Edit</span>
             <span class="bg--secondary py-1 px-2 text-white pointer" @click="showDeleteRoleSwal(role.id)">Delete</span>
           </div>
         </td>
       </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    roles: {
      type: Array,
      requored: false,
      default: () => []
    }
  },
  methods: {
    async deleteRole(roleId) {
      try {
        await this.$repos.userManagementRepo.deleteRole(roleId);
      }catch(error) {
        console.log(error)
      }
    },
    showDeleteRoleSwal(roleId) {
      this.$swal.fire({
      title: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
        if (result.isConfirmed) {
          this.deleteRole(roleId).then(() => {
              this.$emit('updateRoles')
              this.$swal.fire(
                'Deleted!',
                'User role deleted.',
                'success'
              )
          })
        // For more information about handling dismissals please visit
        // https://sweetalert2.github.io/#handling-dismissals
        } else if (result.dismiss === this.$swal.DismissReason.cancel) {
          this.$swal.fire(
            'Cancelled',
            'Delete cancelled :)',
            'error'
          )
        }
      })
    }
  }
}
</script>